import { ORIENTATION_VERSION } from '../content/orientationTour';

export const ORIENTATION_STORAGE_STATUSES = Object.freeze([
    'paused',
    'waiting',
    'dismissed',
    'completed',
]);

const normalizeUserId = (userId) => String(userId || '').trim();

export const getOrientationStorageKey = (userId) => (
    `normative.help.${normalizeUserId(userId)}.orientation`
);

export const getOrientationSessionKey = (userId, version = ORIENTATION_VERSION) => (
    `${getOrientationStorageKey(userId)}.invitation.${version}`
);

const isValidRecord = (record) => (
    record
    && Number.isInteger(record.version)
    && ORIENTATION_STORAGE_STATUSES.includes(record.status)
    && (record.lastStepId === null || typeof record.lastStepId === 'string')
    && (record.checkpointId === undefined || record.checkpointId === null || typeof record.checkpointId === 'string')
    && (record.explicitRestart === undefined || typeof record.explicitRestart === 'boolean')
    && typeof record.updatedAt === 'string'
);

export const readOrientationRecord = ({ storage, userId } = {}) => {
    if (!storage || !normalizeUserId(userId)) return null;

    try {
        const serialized = storage.getItem(getOrientationStorageKey(userId));
        if (!serialized) return null;

        const record = JSON.parse(serialized);
        return isValidRecord(record) ? record : null;
    } catch (error) {
        return null;
    }
};

export const writeOrientationRecord = ({
    storage,
    userId,
    status,
    lastStepId = null,
    checkpointId = null,
    explicitRestart = false,
    version = ORIENTATION_VERSION,
    now = () => new Date(),
} = {}) => {
    if (
        !storage
        || !normalizeUserId(userId)
        || !ORIENTATION_STORAGE_STATUSES.includes(status)
    ) return null;

    const record = {
        version,
        status,
        lastStepId,
        checkpointId,
        ...(explicitRestart ? { explicitRestart: true } : {}),
        updatedAt: now().toISOString(),
    };

    try {
        storage.setItem(getOrientationStorageKey(userId), JSON.stringify(record));
        return record;
    } catch (error) {
        return null;
    }
};

export const isInvitationSuppressed = ({ sessionStorage, userId, version = ORIENTATION_VERSION } = {}) => {
    if (!sessionStorage || !normalizeUserId(userId)) return false;

    try {
        return sessionStorage.getItem(getOrientationSessionKey(userId, version)) === 'true';
    } catch (error) {
        return false;
    }
};

export const suppressInvitation = ({ sessionStorage, userId, version = ORIENTATION_VERSION } = {}) => {
    if (!sessionStorage || !normalizeUserId(userId)) return false;

    try {
        sessionStorage.setItem(getOrientationSessionKey(userId, version), 'true');
        return true;
    } catch (error) {
        return false;
    }
};
